<template>
  <div class="privacy">
    <header-top :headerPosition="false">
      <div slot="title">真人认证条款</div>
    </header-top>
    <div class="privacy-wrapper">
      <div class="privacy-content first">为了打造真实、快捷的交友平台，并提升安全性，「{{appName}}」增加了真人认证环节。</div>
      <div
        class="privacy-content"
      >认证过程中的个人面部生物识别特征信息，将仅用于真人认证的AI智能识别环节，不会应用于用户头像，不会展示给其他用户，不会提供给任何第三方。</div>
      <div class="privacy-content">完成真人认证将获得任务红包、点亮真人认证标签、获得更多异性曝光、收到更多搭讪消息。</div>
      <div class="user-title">完成真人认证，需确认：</div>
      <div class="privacy-content">1、您自愿同意进行真人头像认证；</div>
      <div class="privacy-content">2、您同意授权{{appName}}收集并使用您的真人头像进行认证；</div>
      <div class="privacy-content">3、您同意并授权我们对外展示您的真人头像徽章。</div>
    </div>
  </div>
</template>
<style lang="scss">
.first {
  margin-top: 5.33333vw;
}
.privacy-wrapper {
  padding-top: 120px;
  padding: 120px 30px 0 30px;
  width: 690px;
  text-align: left;
}
.privacy-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.privacy-date {
  margin-left: 300px;
  margin-bottom: 4px;
  text-align: right;
  font-size: 26px;
  width: 390px;
  color: rgb(174, 179, 207);
}
.privacy-date-second {
  margin-bottom: 20px;
}
.privacy-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";

export default {
  name: "Privacy",
  data() {
    return {
      appName: this.$store.state.appName,
    };
  },
  mounted() {},
  components: {
    "header-top": HeaderTop // 顶部导航组件
  }
};
</script>
